import { ProductRecommendationTypes } from "@models/platform-analysis/enums/summary/recommendationType";
import { formatNumberFixed, thousandSeparator } from "@utils";
import { AnalysisSummaryRecommendationLabelConfigs } from "./configs";
import { ProductRecommendationDTO } from "@models/platform-analysis/entities/steps/summary";

export const displayIntNumber = (num?: number): string => {
  const value = num || 0;

  return `${thousandSeparator(parseFloat(formatNumberFixed(value, 0)))}`;
};

export const getProductRecommendationConfigs = (
  recommendationData?: Partial<ProductRecommendationDTO>,
) => {
  const { recommendationType, additionalCustomLabel } =
    recommendationData || {};
  const isCustomType = recommendationType === ProductRecommendationTypes.Custom;

  const label = !recommendationType
    ? null
    : isCustomType
    ? additionalCustomLabel
    : recommendationType;

  const configs =
    recommendationType && label
      ? AnalysisSummaryRecommendationLabelConfigs[recommendationType]
      : null;

  return {
    backgroundColor: configs?.backgroundColor,
    icon: configs?.icon,
    label: label,
    isCustomType: isCustomType,
  };
};
